import React from "react"

const Print = ({ width, height, style, lites }) => {
  return (
    <div className="hidden min-w-full mx-auto justify-center text-center mt-5" id="print">
      <h3 className="text-sm mb-5 font-bold">Your Selection:&nbsp;</h3>
      {width && <span className="text-sm"> {width && ` ${width}' X `}&nbsp;</span>}
      {height && <span className="text-sm"> {height && ` ${height}' - `}&nbsp;</span>}
      {style && <span className="text-sm">{style}&nbsp;</span>}
      {lites && <span className="text-sm">-&nbsp;{lites}&nbsp;</span>}
    </div>
  )
}

export default Print
